<template>
  <Transition name="modal-fade">
    <RiskProfileModal v-if="showRiskModal" @cancel="showRiskModal = false" :open="showRiskModal"/>
  </Transition>
  <Breadcrumb></Breadcrumb>
  <CompanyForm :company="company" :title="$gettext('Nouveau client')" @submit="onSubmit" @cancel="onCancel" />
</template>

<script setup>
import { useCompanyStore } from "@/stores/company";
import { useRouter } from "vue-router";
import CompanyForm from "@/components/companies/CompanyForm.vue";
import Breadcrumb from "@/components/layout/BreadcrumbNavigation.vue";
import RiskProfileModal from "@/components/risk-scorings/RiskProfileModal.vue";
import { ref } from "vue";

const router = useRouter();
const companyStore = useCompanyStore();
const company = companyStore.emptyCompany();
const showRiskModal = ref(false);

const onSubmit = (payload, actions) => {
  companyStore.saveCompany(payload, (company) => {
    showRiskModal.value = true;
    waitForRiskScoring(company.id);
  }, (errors) => {
    actions.setErrors(errors.value);
  });
};

const onCancel = () => {
  router.back();
};

const waitForRiskScoring = async (companyId) => {
  const interval = setInterval(async () => {
    // Need to do a real check for risk scoring completion
    clearInterval(interval);
    showRiskModal.value = false;
    router.push({ name: "company", params: { id: companyId } });
  }, 3000);
  setTimeout(() => {
    clearInterval(interval);
  }, 60000); // Stop checking after 1 minute
};
</script>
